import createReactComponent from '../createReactComponent';
export default createReactComponent('category-minus', 'IconCategoryMinus', [
  [
    'path',
    { d: 'M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6', key: 'svg-0' },
  ],
]);
